import React, { useState, useRef, useReducer, useEffect } from 'react';
import styled from 'styled-components';
import { CurrentSlide, PresenterDocumentView, AllSlides } from '@components';
import { useLocation } from 'react-router';
import { PresentationProvider } from '@context/presentation';
import { Link } from 'react-router-dom';
import { PAGE_URLS, FIRM_FULL_NAMES, VIEWPORTS } from '@constants';
import { salesRepReducer, initialRepState } from '@actions/reducers';
import { setViewport, setLanguage } from '@actions/creators';
import { getAbbreviation } from '@utils/i18n';
import { useTranslation } from 'react-i18next';

// TODO: Make this page less ugly

const TestingPage = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 5rem;
    button {
        margin: 0 5px;
    }
    >div {
        display: flex;
        margin-bottom: 5rem;
        >ul {
            margin-right: 5%;
        }
    }
`;

export const SlideTestingPage = () => {
    const { mobile, tablet, desktop } = VIEWPORTS;
    const [currentlyViewing, setCurrentlyViewing] = useState('Slides');
    const slideRef = useRef(null);
    const { state } = useLocation();
    const { i18n } = useTranslation();

    if (!state) return (
        <div>Please enter info on the <Link to={PAGE_URLS.CLIENT_LOGIN}>client login</Link> page.</div>
    );

    const [slideState, dispatch] = useReducer(salesRepReducer, initialRepState);
    const { language } = slideState;

    useEffect(() => {
        i18n.changeLanguage(getAbbreviation(language));
    }, [language]);

    const [clientState, setClientState] = useState({
        ...state.client,
        firstName: 'Test',
        lastName: 'Client',
        firm: 'Royal Legal Group',
        language: 'English'
    });

    const viewports = [mobile, tablet, desktop];

    function handleProfileChange(event) {
        const firm = event.target.value;

        setClientState({
            ...clientState, firm        
        });
    }

    const changeLanguage = async (event) => {
        const { value } = event.target;

        dispatch(setLanguage(value));
    };

    function handlePresentationChange(event) {
        const { value } = event.target;
        setCurrentlyViewing(value);
    }

    function updateSlideView(event) {
        const viewportType = event.target.value;

        switch(viewportType) {
            case mobile:
                dispatch(setViewport(mobile));
                slideRef.current.style.width = '390px';
                break;
            case tablet:
                dispatch(setViewport(tablet));
                slideRef.current.style.width = '560px';
                break;
            default:
                dispatch(setViewport(desktop));
                slideRef.current.style.width = '768px';
        }
    }

    return (
        <PresentationProvider client={clientState} clientViewing={false}>
            <TestingPage>
                <Link to={PAGE_URLS.CLIENT_LOGIN}>Back to login</Link>
                <select onChange={handlePresentationChange} data-testid='presentation-type'>
                    <option>Slides</option>
                    <option>Documents</option>
                </select>
                <ul>
                    {
                        viewports.map(type => (
                            <button
                                onClick={updateSlideView}
                                value={type}
                                key={type}>
                                    {type}
                            </button>
                        ))
                    }
                </ul>
                <select data-testid='firms' onChange={handleProfileChange}>
                    {
                        FIRM_FULL_NAMES.map(profile => {
                            return (
                                <option key={profile} value={profile}>
                                    {profile}
                                </option>
                            );
                        })
                    }
                </select>
                <label htmlFor='languages'>
                    Select a language
                </label>
                <select id='languages' onChange={changeLanguage}>
                    <option>English</option>
                    <option>Spanish</option>
                </select>
                <div>
                    {
                        currentlyViewing === 'Slides' ? (
                            <>
                                <AllSlides
                                    addSlide={true}
                                    dispatch={dispatch} />
                                <CurrentSlide
                                    slideState={slideState}
                                    slideId={slideState.slideId}
                                    dispatch={dispatch}
                                    showScript={false}
                                    ref={slideRef}/>
                            </>
                        ) : <PresenterDocumentView 
                                testingPageStyle={true} 
                                slideState={slideState}
                                dispatch={dispatch}
                                slideRef={slideRef} />
                    }
                </div>
            </TestingPage>
        </PresentationProvider>
    );
};

export default SlideTestingPage;
